import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Audience() {
  return <section className="bg-bordo text-crema py-20 px-4 md:px-8" data-id="element-14">
      <div className="max-w-4xl mx-auto text-center" data-id="element-15">
        <h2 className="text-3xl md:text-5xl font-serif font-bold mb-12 text-dorado" data-id="element-16">
          Esto es para vos si…
        </h2>

        <div className="space-y-6 text-lg md:text-xl mb-16 text-left max-w-2xl mx-auto" data-id="element-17">
          <motion.p initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex items-center gap-4" data-id="element-18">
            <span className="text-2xl" data-id="element-19">🥩</span> Amás las milanesas. Pero estás
            cansado de hacerlas siempre igual.
          </motion.p>
          <motion.p initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="flex items-center gap-4" data-id="element-20">
            <span className="text-2xl" data-id="element-21">⏱️</span> También es para vos si tenés
            poco tiempo y necesitás comidas rápidas.
          </motion.p>
          <motion.p initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="flex items-center gap-4" data-id="element-22">
            <span className="text-2xl" data-id="element-23">👨‍👩‍👧‍👦</span> Si cocinás para tu familia y
            querés resolver sin pensar demasiado.
          </motion.p>
          <motion.p initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="flex items-center gap-4" data-id="element-24">
            <span className="text-2xl" data-id="element-25">🧘‍♂️</span> Si querés comer rico, pero sin
            vivir estresado por la cocina.
          </motion.p>
          <motion.p initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="flex items-center gap-4" data-id="element-26">
            <span className="text-2xl" data-id="element-27">📅</span> Si querés tener recetas
            prácticas, combinaciones y organización semanal.
          </motion.p>
        </div>

        <div className="bg-bordo-dark p-8 rounded-2xl shadow-xl mb-12" data-id="element-28">
          <p className="text-2xl font-serif font-bold mb-6" data-id="element-29">Y sobre todo…</p>
          <p className="text-xl md:text-2xl text-dorado font-bold mb-8" data-id="element-30">
            si querés que una comida simple vuelva a darte ganas.
          </p>
        </div>

        <CTAButton data-id="element-31" />
      </div>
    </section>;
}